import { GetOfficesListingSchema } from '../schemas/OfficeZodSchema';
import { Office } from '../types/Office';

export function transformOfficeResponse(data?: unknown): Office[] {
    const parsedResult = GetOfficesListingSchema.safeParse(data);

    if (!parsedResult.success) {
        console.error('Validation failed for getOfficesListing:', parsedResult.error.errors);
        return [];
    }

    const parsedOffices = parsedResult.data.getObjectFolder.children;

    return parsedOffices.map((o) => ({
        id: o.id,
        key: o.key,
        name: o.name,
        phone: o.phone ?? null,
        email: o.email ?? null,
        salesAddressLine1: o.salesAddressLine1 ?? null,
        salesAddressLine2: o.salesAddressLine2 ?? null,
        salesAddressLine3: o.salesAddressLine3 ?? null,
        countryId: o.country.id,
        logo: o.logo ?? null,
    }));
}
